export class GetBulkRestoreSnapshotHistogramResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "buckets",
            "baseName": "buckets",
            "type": "Array<SnapshotHistogramBucket>",
            "format": ""
        },
        {
            "name": "totalResources",
            "baseName": "totalResources",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetBulkRestoreSnapshotHistogramResponse.attributeTypeMap;
    }
    constructor() {
    }
}
